import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const RegisterIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M4.6875 6.25C4.6875 4.00634 6.50634 2.1875 8.75 2.1875H31.25C33.4937 2.1875 35.3125 4.00634 35.3125 6.25V33.75C35.3125 35.9937 33.4937 37.8125 31.25 37.8125H8.75C6.50634 37.8125 4.6875 35.9937 4.6875 33.75V6.25Z"
          fill="#E4E0FF"
        />
        <path
          d="M24.6875 10C24.6875 12.5888 22.5888 14.6875 20 14.6875C17.4112 14.6875 15.3125 12.5888 15.3125 10C15.3125 7.41117 17.4112 5.3125 20 5.3125C22.5888 5.3125 24.6875 7.41117 24.6875 10Z"
          fill="#C0AAFE"
        />
        <path
          d="M10 17.1875C10 16.6697 10.4197 16.25 10.9375 16.25H29.0625C29.5803 16.25 30 16.6697 30 17.1875V19.6875C30 20.2053 29.5803 20.625 29.0625 20.625H10.9375C10.4197 20.625 10 20.2053 10 19.6875V17.1875Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5625 18.4375C11.5625 18.0923 11.8423 17.8125 12.1875 17.8125H21.25C21.5952 17.8125 21.875 18.0923 21.875 18.4375C21.875 18.7827 21.5952 19.0625 21.25 19.0625H12.1875C11.8423 19.0625 11.5625 18.7827 11.5625 18.4375Z"
          fill="#0F3893"
        />
        <path
          d="M10.9375 16.25C10.4197 16.25 10 16.6697 10 17.1875V19.6875C10 20.2053 10.4197 20.625 10.9375 20.625H29.0625C29.5803 20.625 30 20.2053 30 19.6875V17.1875C30 16.6697 29.5803 16.25 29.0625 16.25H10.9375Z"
          fill="white"
        />
        <path
          d="M10.9375 22.1875C10.4197 22.1875 10 22.6072 10 23.125V25.625C10 26.1428 10.4197 26.5625 10.9375 26.5625H29.0625C29.5803 26.5625 30 26.1428 30 25.625V23.125C30 22.6072 29.5803 22.1875 29.0625 22.1875H10.9375Z"
          fill="white"
        />
        <path
          d="M12.8125 24.375C12.8125 24.7202 12.5327 25 12.1875 25C11.8423 25 11.5625 24.7202 11.5625 24.375C11.5625 24.0298 11.8423 23.75 12.1875 23.75C12.5327 23.75 12.8125 24.0298 12.8125 24.375Z"
          fill="#0F3893"
        />
        <path
          d="M14.6875 24.375C14.6875 24.7202 14.4077 25 14.0625 25C13.7173 25 13.4375 24.7202 13.4375 24.375C13.4375 24.0298 13.7173 23.75 14.0625 23.75C14.4077 23.75 14.6875 24.0298 14.6875 24.375Z"
          fill="#0F3893"
        />
        <path
          d="M15.9375 25C16.2827 25 16.5625 24.7202 16.5625 24.375C16.5625 24.0298 16.2827 23.75 15.9375 23.75C15.5923 23.75 15.3125 24.0298 15.3125 24.375C15.3125 24.7202 15.5923 25 15.9375 25Z"
          fill="#0F3893"
        />
        <path
          d="M18.4375 24.375C18.4375 24.7202 18.1577 25 17.8125 25C17.4673 25 17.1875 24.7202 17.1875 24.375C17.1875 24.0298 17.4673 23.75 17.8125 23.75C18.1577 23.75 18.4375 24.0298 18.4375 24.375Z"
          fill="#0F3893"
        />
        <path
          d="M19.6875 25C20.0327 25 20.3125 24.7202 20.3125 24.375C20.3125 24.0298 20.0327 23.75 19.6875 23.75C19.3423 23.75 19.0625 24.0298 19.0625 24.375C19.0625 24.7202 19.3423 25 19.6875 25Z"
          fill="#0F3893"
        />
        <path
          d="M22.1875 24.375C22.1875 24.7202 21.9077 25 21.5625 25C21.2173 25 20.9375 24.7202 20.9375 24.375C20.9375 24.0298 21.2173 23.75 21.5625 23.75C21.9077 23.75 22.1875 24.0298 22.1875 24.375Z"
          fill="#0F3893"
        />
        <path
          d="M23.4375 25C23.7827 25 24.0625 24.7202 24.0625 24.375C24.0625 24.0298 23.7827 23.75 23.4375 23.75C23.0923 23.75 22.8125 24.0298 22.8125 24.375C22.8125 24.7202 23.0923 25 23.4375 25Z"
          fill="#0F3893"
        />
        <path
          d="M18.0469 8.75488C18.0469 7.66272 18.9213 6.77734 20 6.77734C21.0787 6.77734 21.9531 7.66272 21.9531 8.75488C21.9531 9.84705 21.0787 10.7324 20 10.7324C18.9213 10.7324 18.0469 9.84705 18.0469 8.75488Z"
          fill="#0F3893"
        />
        <path
          d="M16.5248 13.1458C16.5433 13.063 16.5698 12.9786 16.6075 12.8951C16.7404 12.6012 17.0163 12.1541 17.5572 11.7817C18.1001 11.408 18.8834 11.1279 20 11.1279C21.1166 11.1279 21.8999 11.408 22.4428 11.7817C22.9837 12.1541 23.2596 12.6012 23.3924 12.8951C23.4302 12.9786 23.4567 13.063 23.4751 13.1458C22.6175 14.0927 21.3782 14.6875 20 14.6875C18.6218 14.6875 17.3825 14.0927 16.5248 13.1458Z"
          fill="#0F3893"
        />
        <path
          d="M12.1875 17.8125C11.8423 17.8125 11.5625 18.0923 11.5625 18.4375C11.5625 18.7827 11.8423 19.0625 12.1875 19.0625H21.25C21.5952 19.0625 21.875 18.7827 21.875 18.4375C21.875 18.0923 21.5952 17.8125 21.25 17.8125H12.1875Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75 1.25C5.98858 1.25 3.75 3.48858 3.75 6.25V33.75C3.75 36.5114 5.98858 38.75 8.75 38.75H31.25C34.0114 38.75 36.25 36.5114 36.25 33.75V6.25C36.25 3.48858 34.0114 1.25 31.25 1.25H8.75ZM5.625 6.25C5.625 4.52411 7.02411 3.125 8.75 3.125H31.25C32.9759 3.125 34.375 4.52411 34.375 6.25V33.75C34.375 35.4759 32.9759 36.875 31.25 36.875H8.75C7.02411 36.875 5.625 35.4759 5.625 33.75V6.25Z"
          fill="#0F3893"
        />
        <path
          d="M28.125 5.78125C28.125 6.21272 27.7752 6.5625 27.3438 6.5625C26.9123 6.5625 26.5625 6.21272 26.5625 5.78125C26.5625 5.34978 26.9123 5 27.3438 5C27.7752 5 28.125 5.34978 28.125 5.78125Z"
          fill="#006DFF"
        />
        <path
          d="M30.3125 5.78125C30.3125 6.21272 29.9627 6.5625 29.5312 6.5625C29.0998 6.5625 28.75 6.21272 28.75 5.78125C28.75 5.34978 29.0998 5 29.5312 5C29.9627 5 30.3125 5.34978 30.3125 5.78125Z"
          fill="#006DFF"
        />
        <path
          d="M31.7188 6.5625C32.1502 6.5625 32.5 6.21272 32.5 5.78125C32.5 5.34978 32.1502 5 31.7188 5C31.2873 5 30.9375 5.34978 30.9375 5.78125C30.9375 6.21272 31.2873 6.5625 31.7188 6.5625Z"
          fill="#006DFF"
        />
        <path
          d="M12.8125 28.4375C11.2592 28.4375 10 29.6967 10 31.25C10 32.8033 11.2592 34.0625 12.8125 34.0625H27.1875C28.7408 34.0625 30 32.8033 30 31.25C30 29.6967 28.7408 28.4375 27.1875 28.4375H12.8125Z"
          fill="#006DFF"
        />
      </svg>
    );
  }
);

export default RegisterIcon;
